import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { ListboxOptionGetterProps } from './use-listbox';

const liStyles = (liStylesProps: ListboxOptionGetterProps) => css`
  color: ${theme.colors.neutral90};
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${theme.fontSize(16)};
  line-height: 1.375;
  padding: ${theme.spacing(1, 2)};
  ${liStylesProps['aria-disabled']
    ? `color: ${theme.colors.neutral20};
       cursor: not-allowed;`
    : `:hover,
      &[data-focused='true'] {
      background: ${theme.colors.neutral5};
      }`}
`;

const iconStyles = (iconStylesProps: ListboxOptionGetterProps) => css`
  flex-shrink: 0;
  margin-left: ${theme.spacing(2)};
  visibility: ${iconStylesProps['aria-selected'] ? 'visible' : 'hidden'};
`;

export const ListboxLiStyles = {
  liStyles: (props: ListboxOptionGetterProps) => liStyles(props),
  iconStyles: (props: ListboxOptionGetterProps) => iconStyles(props),
};
